export default __webpack_public_path__ + "static/media/leaderboard-Logo-neon.85c32a34.svg";